import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { applyThemeAndConfiguration } from "./applyStylingTheme";
import { CapitalThemeLoaderWeb } from "./CapitalThemeLoaderWeb";
const CapitalThemeLoaderJson = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const platform = Capacitor.getPlatform();
        let isActive = true;
        let themePath = "/client/theme.json";
        if (platform !== "web") {
            themePath = `${window.argonBaseUrl}${themePath}`;
        }
        fetch(themePath)
            .then((response) => response.json())
            .then((data) => {
            if (isActive) {
                applyThemeAndConfiguration(data);
                setIsLoading(false);
            }
        })
            .catch((error) => console.log(error.message));
        return () => {
            isActive = false;
        };
    }, []);
    if (isLoading) {
        return null;
    }
    return children;
};
const CapitalThemeLoader = ({ children }) => {
    if (process.env.FORTIS_ENABLE_WEB_THEME === "true") {
        return _jsx(CapitalThemeLoaderWeb, { children: children });
    }
    return _jsx(CapitalThemeLoaderJson, { children: children });
};
export default CapitalThemeLoader;
